import {ReactComponent as NotFoundIcon} from './404.svg'

function NotFound() {
  return <NotFoundIcon />
}

export default NotFound
